function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/ico-30-warning");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/ico-30-warning",
  stroke: "#D62837"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.5,4.5 L26.5,24.5 L4.5,24.5 L15.5,4.5 Z M15.5,19.5 C14.9477153,19.5 14.5,19.9477153 14.5,20.5 C14.5,21.0522847 14.9477153,21.5 15.5,21.5 C16.0522847,21.5 16.5,21.0522847 16.5,20.5 C16.5,19.9477153 16.0522847,19.5 15.5,19.5 Z M15.5,11 C14.9477153,11 14.5,11.4477153 14.5,12 L14.5,12 L14.5,16 C14.5,16.5522847 14.9477153,17 15.5,17 C16.0522847,17 16.5,16.5522847 16.5,16 L16.5,16 L16.5,12 C16.5,11.4477153 16.0522847,11 15.5,11 Z",
  id: "Combined-Shape"
})));

const SvgIco30Warning = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Warning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-warning.29df00d8.svg";
export { ForwardRef as ReactComponent };